import axios from "@/utils/request";
interface ConsultCloudData {
    data: string
}
export const consultCloud = (options: object) => axios<ConsultCloudData>({
    method: 'POST',
    url: 'diga/aileyun/consult',
    data: options
})